import { render, staticRenderFns } from "./comBox.vue?vue&type=template&id=4571f9fa&scoped=true&"
import script from "./comBox.vue?vue&type=script&lang=js&"
export * from "./comBox.vue?vue&type=script&lang=js&"
import style0 from "./comBox.vue?vue&type=style&index=0&id=4571f9fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4571f9fa",
  null
  
)

export default component.exports